<svelte:options tag="fds-image-editor-text"></svelte:options>
<script>
    import { onMount } from "svelte"
    import fdsHelper from "@fds-components/fds-helper"
   // let path = fdsHelper.get_href()
    import {get_current_component} from "svelte/internal"
    let host = get_current_component()
    import { version as componentversion, name } from "../package.json"
    // eslint-disable-next-line no-unused-vars
    import Dialog from './Dialog.svelte';

        /**
     * width of canvas
     * @type {integer}
     */
    export let width=500
    /**
     * height of canvas
     * @type {integer}
     */    
    export let height=500
    /**
     * object with data property to save scene on destroy 
     */
    export let external_scene_storage=null

    
    /**
     * Get information about component
     * @param  {("api" | "examples" | "css")} type the info type
     */
    export async function getInfo(type) {
        if (type === "version") {
            return new Promise((resolve) => {
                resolve(componentversion);
            });
        }
        let res = await fdsHelper.getInfo(type, name);
        return res;
    }

    /**
     * version of component
     * @type {string}
     */
    export const version = componentversion;


    function _destroy() {
        if (!external_scene_storage) return
        external_scene_storage.data=getScene()
    }
    onMount(() => {
        return () => {
            _destroy()
        }
    })    
    

    /**
     * check all styleSheets
     * external link or imported stylesheets
     * need to be fetched and inlined
     * to create font Files object
     */
    async function getFontReferences() {
    let fontFiles = [];

    // inline external css
    let styleSheets = await inlineExternalCss(true, true);

    styleSheets.forEach((styleSheet, s) => {
        let cssRules = styleSheet.cssRules;

        for (let i = 0; i < cssRules.length; i++) {
        let rule = cssRules[i];
        let typeRule = rule.type;

        // type===5: is @font-face rule
        if (typeRule === 5) {
            let style = rule.style;
            let fontFamily = style.fontFamily.replaceAll('"', "");
            let fontWeight = parseFloat(style.fontWeight);
            let fontStyle = style.fontStyle;
            let unicodeRange = style.unicodeRange;

            let src = style.src
            .split(",")
            .map((val) => {
                return val.split(" ")[0];
            })
            .filter(Boolean);
            let url = "";

            // extract font file URLs/paths
            src.forEach((fontSrc) => {
            url = fontSrc.match(/\(([^)]+)\)/)[1].replaceAll('"', "");
            });

            // add to fontFiles object
            fontFiles.push({
            origin: origins[s],
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontStyle: fontStyle,
            src: url,
            unicodeRange: unicodeRange
            });
        }
        }
    });

    console.log(fontFiles);
    return fontFiles;
    }

    /**
     * inline all external stylesheets
     */

    // collect all css origins
    let origins = [];

    async function inlineExternalCss(removeExternalCss = true) {
    let styleSheets = Array.from(document.styleSheets);

    /**
     * stylesheet helper
     * fetch external css
     */
    const fetchExternalStylesheet = async (href, ind = 0) => {
        let fetched = await fetch(href);
        let css = await fetched.text();
        let newStyle = document.createElement("style");
        newStyle.classList.add("externalCSS");
        let externalCss = document.head.querySelectorAll(".externalCSS");
        if (!externalCss.length) {
        document.head.insertBefore(newStyle, document.head.children[0]);
        } else {
        document.head.insertBefore(
            newStyle,
            externalCss[externalCss.length - 1].nextElementSibling
        );
        }
        newStyle.textContent = `/** origin: ${href} **/\n` + css;
        origins.push(href);
    };

    for (let i = 0; i < styleSheets.length; i++) {
        let stylesheet = styleSheets[i];
        let href = stylesheet.href;

        // fetch external stylesheet
        if (href) {
        await fetchExternalStylesheet(href, i);
        } else {
        let cssRules = stylesheet.cssRules;
        let cssRulesL = cssRules.length;
        for (let r = 0; r < cssRulesL; r++) {
            let rule = cssRules[r];
            let type = rule.type;

            // is @import rule - fetch external stylesheet
            if (type === 3) {
            let href = rule.href;
            if (href) {
                if (removeExternalCss) {
                stylesheet.deleteRule(r);
                cssRulesL--;
                r--;
                }
                await fetchExternalStylesheet(href, r);
            }
            } else if (type === 5) {
            origins.push("local");
            }
        }
        }
    }

    // remove external stylesheet
    if (removeExternalCss) {
        let styleSheetLinks = document.querySelectorAll(
        'link[href$=".css"], link[rel="stylesheet"]'
        );
        for (let i = 0; i < styleSheetLinks.length; i++) {
        let link = styleSheetLinks[i];
        await link.remove();
        }
    }

    let styleSheetsInlined = Array.from(document.styleSheets);
    return styleSheetsInlined;
    }
     async function getFontData() {
        let fontRefs=await getFontReferences()
        let fontURL=""
        for(let f of fontRefs) {
            if (font===f.fontFamily) {
                fontURL=f.src
            }
        }
        if (!fontURL)  return 
        let resp = await fetch(fontURL);
        let blob = await resp.blob()
        return new Promise((resolve) => {
            let f = new FileReader()
            f.addEventListener('load', () => resolve(f.result))
            f.readAsDataURL(blob);
        })
    }
       
    export async function renderForAI() {
                // first load the font

        let fontData=await getFontData()
        let style=""
        if (fontData) {
            style="<style>\n @font-face { font-family: '"+font+"';"
            style+="\nsrc: url("+fontData+") format('woff2');\n</style> "
        }
           
        let svgData = new XMLSerializer().serializeToString(svg)
        console.log(svgData)
        svgData=svgData.replace("<defs/>","<defs>"+style+"</defs>")   // embed font
        const svgDataBase64 = btoa(unescape(encodeURIComponent(svgData)))        
        const svgDataUrl = `data:image/svg+xml;charset=utf-8;base64,${svgDataBase64}`        
        const canvas = document.createElement('canvas')
        let image = new Image()
        return new Promise((resolve) => {
            image.addEventListener('load', () => {
                canvas.setAttribute('width', width)
                canvas.setAttribute('height', height)
                const context = canvas.getContext('2d')
                context.drawImage(image, 0, 0, width, height)
                const dataUrl = canvas.toDataURL('image/png')
                resolve(dataUrl)
            })
            image.src = svgDataUrl
        })

    }
        



   
   
    export let text="Hello"
    export let font_size=150
    export let font
    export let align="middle"
    export let background="transparent"
    export let letter_spacing=0
    export let bold=false;
    export let italic=false;
    export let underline=false;
    let fontweight="normal";
    let fontstyle="normal";
    let textdecoration="none";

    $: {
        if(bold){
            fontweight = "bold";
        }  else{
            fontweight = "normal";
        }

        if(italic){
            fontstyle="italic";
        }else{
            fontstyle="normal";
        }

        if(underline){
            textdecoration="underline";
        }else{
            textdecoration="none";
        }



        if (text) {
            calcText()
        }
        if (font_size) {
            calcText()
        }
        if (width || height) {
            calcInnerSize()
        }
    }
    let innerHeight=1000
    let innerWidth=1000
    function calcInnerSize() {
        let ar=width/height
        if (width>height) {
            innerHeight=1000/ar
            innerWidth=1000
        } else {
            innerWidth=1000/ar
            innerHeight=1000
        }
    }
    let lines=[]
    let lineHeight
    let yStart
    function calcText() {
        lines=text.split("\n")
        lineHeight=font_size*1.2
        yStart=-(lineHeight*(lines.length-1))/2
        console.log(lines,lineHeight)
    }
    /**
     * get full scene data: camera and all poses
     */
    export function getScene() {
        let scene={  text, font_size,font,align,background}
        let sceneData=JSON.parse(JSON.stringify(scene))
        return sceneData
    }
    /**
     * set scene and pose data
     */
     export async function setScene(sceneInfo) {
        text=sceneInfo.text
        font_size=sceneInfo.font_size
        font=sceneInfo.font
        align=sceneInfo.align
        background=sceneInfo.background
    }

    /**
     * make image from current scene 
     * @return: base64-url
     */
    export async function renderNormal() {
//        let url=canvas.toDataURL()             
//        setMode(oldMode)
let url=""
        return url
    }
   


    function dispatchChange(info) {
        host.dispatchEvent( new CustomEvent("change",info))
    }

    


  
    
    /**
     * canvas can be used somewhere else
     */
    export let svg
</script>
{letter_spacing}
<svg {width}  {height} style="background:{background}"  viewBox="0 0 {innerWidth} {innerHeight}" bind:this={svg}>
    <defs></defs>

    <text x="0" y="{innerHeight/2}"  style="text-decoration:{textdecoration}; font-style:{fontstyle}; font-weight:{fontweight}; font-size:{font_size}px;font-family:'{font}';letter-spacing:{letter_spacing}rem"  dominant-baseline="middle" >
        {#each lines as text,i}       
            <tspan x="{innerWidth/2}" y="{innerHeight/2}" dy="{yStart+lineHeight*i}px" text-anchor="{align}">{text}</tspan>
        {/each}
    </text>
  </svg>
<style>
    .svg {
        width:100%;
        height:100%;
    }
    * {
        box-sizing: border-box;
    }
    /** delete this CSS: */
</style>
